import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'modules/store';

const selectState = (x: RootState) => x.reportsReducer;

export const selectReports = createSelector(selectState, ({ reports }) => reports);
export const selectIsLoading = createSelector(selectState, ({ isLoading }) => isLoading);
